// Constants for DOM element references (Seal-specific prefixes added)
const SEAL_SUBS_TARGET_ELEMENT_SELECTOR = ".sealsubs-target-element.sealsubs-full";
const SEAL_SUBSCRIPTION_WRAPPER_ID = "niuriss-seal-subscription";
const SEAL_QUANTITY_INPUT_NAME = "quantity";
const SEAL_VARIANT_SELECTOR_REF = '[x-ref="singleVariantSelector"]';

// Event listener for Seal subscription widget creation
document.addEventListener("sealsubs:subscription_widget_created", function (e) {
  const sealSubscriptionTargetElements = document.querySelectorAll(SEAL_SUBS_TARGET_ELEMENT_SELECTOR);
  const sealSubscriptionWrapper = document.getElementById(SEAL_SUBSCRIPTION_WRAPPER_ID);
  const sealQuantityInput = document.querySelector(`input[name="${SEAL_QUANTITY_INPUT_NAME}"]`);

  const sealSubscriptionTargetElement = sealSubscriptionTargetElements[0];
  if (sealSubscriptionTargetElement) {
    if(sealSubscriptionWrapper) {
      // Structure manipulation for Seal subscription widget
      sealSubscriptionTargetElement.parentElement.insertBefore(sealSubscriptionWrapper, sealSubscriptionTargetElement);
      sealSubscriptionWrapper.appendChild(sealSubscriptionTargetElement);
  
      // Event listeners for Seal subscription quantity change
      [sealQuantityInput.nextElementSibling, sealQuantityInput.previousElementSibling].forEach(el =>
        el.addEventListener("click", handleSealSubscriptionChange)
      ); 
    } else {
      sealSubscriptionTargetElements.forEach( el => el.style.display = 'none');
    }
  } else {
    // Error logging for Seal subscription widget elements
    console.error(
      !sealSubscriptionTargetElement 
        ? `Seal subscription target element '${SEAL_SUBS_TARGET_ELEMENT_SELECTOR}' not found.`
        : `Seal subscription wrapper element '${SEAL_SUBSCRIPTION_WRAPPER_ID}' not found.`
    );
  }
});

// Event listener for Seal subscription price updates
document.addEventListener("sealsubs:price_update", handleSealSubscriptionChange);

// Function to handle Seal subscription changes
function handleSealSubscriptionChange() {
  const sealVariantSelector = document.querySelector(SEAL_VARIANT_SELECTOR_REF);
  const sealVariantId = sealVariantSelector?.querySelector("option:checked")?.value;
  const sealQuantity = document.querySelector(`input[name="${SEAL_QUANTITY_INPUT_NAME}"]`).value;

  const sealSubscriptionWrapper = document.getElementById(SEAL_SUBSCRIPTION_WRAPPER_ID);
  const isSealOneTimePurchase = (sealVariantId === "48678343606578" || sealVariantId === "49922936406322") && (sealQuantity === "1" || sealQuantity === "2");

  // Toggle class for Seal one-time purchase styling
  sealSubscriptionWrapper.classList.toggle("niuriss-seal-one-order", isSealOneTimePurchase);

  // Simulate Seal one-time purchase option selection (if necessary)
  if (isSealOneTimePurchase) {
    const sealOneTimePurchaseElement = document.querySelector(".sls-option-container.seal-table");
    sealOneTimePurchaseElement.click();
  }
}
